import React, { useRef, useState } from "react";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import FilesActionGroup from "../../Reusable/FilesActionGroup/FilesActionGroup.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import { useMailView } from "../../../contexts/mailViewContext/mailViewContext.js";
import { useCloseLightBox } from "../../../hooks/useCloseLightBox.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { useActionList } from "hooks/useActionList.js";
import { TranscodingElement } from "components/Reusable/Grid/Grid/GridItem.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";

const LightBoxHeader = ({ ignoreUrl }) => {
  const {
    getFilesData,
    getMailSecurity,
    getCollectionsList,
    getCollectionsData,
    isFileInCollection,
    removeFilesFromCollection,
    addFilesToCollection,
  } = useMail();
  const { toggleFileSelect, getFileSelected } = useMailView();
  const { getFileId, getFileData } = useLightBox();
  const { getSideBarViewLightBox } = useSideBar();
  const { getDirection } = useContent();

  const [showList, setShowList] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, () => setShowList(false));

  const actionList = useActionList({
    security: getMailSecurity(),
  });

  const headerIcons = {
    Image: "image",
    Audio: "music-note",
    Video: "cinema",
    Zip: "zip",
    pdf: "pdf",
    Doc: "file",
  };

  const fileData = getFileData() || getFilesData()[getFileId()];

  const headerIcon =
    fileData.Type === "Doc"
      ? headerIcons[fileData.Extention] || headerIcons.Doc
      : headerIcons[fileData.Type];

  //INBOX+MAILDATA
  const closeLightBox = useCloseLightBox();

  const isSelfRemove = useSelfRemovalLink();

  return (
    <div
      className={`lightBox-header row ${
        getSideBarViewLightBox() ? "lightbox-open" : ""
      }`}
    >
      <div
        onClick={closeLightBox}
        className={`close-section close-section-${getDirection()}`}
      >
        <Tooltip
          id={"closeLightboxIcon"}
          tooltipTextKey="close-lightbox-tooltip-text"
          top
        >
          <Icon name="arrow-back" white />
        </Tooltip>
      </div>
      <div className="file-name">
        <Icon name={headerIcon} white />
        <span>&#x200E;{fileData.Name}</span>
      </div>
      {ignoreUrl ? null : (
        <>
          <div
            className={`selection-container${
              getFileSelected(getFileId()) ? " selected" : ""
            }`}
            onClick={() => toggleFileSelect(getFileId())}
          >
            <Tooltip
              id={"collectionActionIcon" + getFileId()}
              tooltipTextKey="select-file-icon-tooltip-text"
              small
            >
              <div className="select-icon">
                <Icon name="check" white />
              </div>
            </Tooltip>
          </div>
          <TranscodingElement fileData={fileData} />
          {getCollectionsList().length > 0 ? (
            <div
              className="selection-container"
              onClick={(e) => {
                setShowList((prev) => !prev);
                e.stopPropagation();
              }}
              ref={ref}
            >
              <Tooltip tooltipTextKey="add-to-collection-icon-tooltip-text">
                <div className="collection-action-icon">
                  <Icon name="collections" white small />
                </div>
              </Tooltip>
              <AnimationContainer
                animationOn={showList}
                animationClassName="hover-item-fade"
              >
                <div
                  className="collections-list-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  {getCollectionsList().map((item) => {
                    const elem = getCollectionsData()[item];
                    return (
                      <div className={"collection-select-element"} key={item}>
                        <div className="collection-name">
                          {elem.collectionName}
                        </div>
                        <div
                          className="collection-action"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {isFileInCollection(item, getFileId()) ? (
                            <Tooltip
                              id={"deleteFromCollectionIcon" + item}
                              tooltipTextKey="delete-from-collection-icon-tooltip-text"
                            >
                              <Icon
                                name="trash-solid"
                                white
                                small
                                onClick={() => {
                                  removeFilesFromCollection(item, [
                                    getFileId(),
                                  ]);
                                }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip
                              id={"addToCollectionIcon" + item}
                              tooltipTextKey="add-to-collection-icon-tooltip-text"
                            >
                              <Icon
                                name="plus"
                                white
                                small
                                onClick={() => {
                                  addFilesToCollection(item, [getFileId()]);
                                }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </AnimationContainer>
            </div>
          ) : null}
        </>
      )}
      <div className="flex-spacer"></div>
      <div className="col-5 pull-end action-list">
        {ignoreUrl || isSelfRemove ? null : (
          <FilesActionGroup
            actionList={actionList}
            lightBox={true}
            itemId={getFileId()}
          />
        )}
      </div>
    </div>
  );
};

export default LightBoxHeader;
